import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import TabsMaterial from 'components/TabsMaterial';
import { tabsList } from './listTabsflag';
import DataProductsCarousel from 'components/DataProductsCarousel';
import AddProductInCarousel from 'components/AddProductInCarousel';
import { DataFormProps } from 'types/InputsProductCarouselProps';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import { Product } from 'types/Product';

const initialData: DataFormProps = {
	name: '',
	description: '',
	reference_id: '',
	schedule_end: '',
	schedule_start: '',
	countdown: false,
	qtdAllProducts: 0,
	products: []
};

export default function InputsProductCarousel() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		setModuleOnPhoneToEdit,
		moduleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialData);
	const [products, setProducts] = useState<Product[]>([]);
	const [tabSelected, setTabSelected] = useState(0);
	const [isShowDateInputs, setIsShowDateInputs] = useState(false);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => {
					const newObj = { ...obj, ...moduleOnPhoneToEdit.data };

					return newObj;
				});

				if (
					moduleOnPhoneToEdit?.data?.schedule_end !== '' ||
					moduleOnPhoneToEdit?.data?.schedule_start !== ''
				) {
					setIsShowDateInputs(true);
				}
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />

			<DataProductsCarousel
				isShowDateInputs={isShowDateInputs}
				setIsShowDateInputs={setIsShowDateInputs}
				isShow={tabSelected === 0}
				dataForm={dataForm}
				setDataForm={setDataForm}
				setProducts={setProducts}
			/>
			<AddProductInCarousel
				isShow={tabSelected === 1}
				listProducts={products}
			/>
		</S.container>
	);
}
